var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11,20.5c-1.2,0-2.3-.2-3.3-.7-1-.4-1.9-1-2.7-1.8-.8-.8-1.4-1.7-1.8-2.7-.4-1-.7-2.1-.7-3.3s.2-2.3.7-3.3c.4-1,1-1.9,1.8-2.7s1.7-1.4,2.7-1.8c1-.4,2.1-.7,3.3-.7s.7,0,1,0,.7.1,1,.2v1.6c-.3-.1-.7-.2-1-.2s-.7,0-1,0c-2,0-3.6.7-5,2-1.4,1.4-2,3-2,5s.7,3.6,2,5c1.4,1.4,3,2,5,2s3.6-.7,5-2c1.4-1.4,2-3,2-5s0-.4,0-.5c0-.2,0-.3,0-.5h1.5c0,.2,0,.3,0,.5,0,.2,0,.4,0,.5,0,1.2-.2,2.3-.7,3.3-.4,1-1,1.9-1.8,2.7-.8.8-1.7,1.4-2.7,1.8-1,.4-2.1.7-3.3.7ZM14,16l-3.7-3.7v-5.3h1.5v4.7l3.3,3.3s-1.1,1.1-1.1,1.1ZM18,8.9v-3h-3v-1.5h3V1.4h1.5v3h3v1.5h-3v3h-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreTime);
export default __webpack_public_path__ + "static/media/more_time.a854bc35e41a6fd6821797fcf0ce086b.svg";
export { ForwardRef as ReactComponent };